<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <PageHeader :title="title" :items="items" />
        <b-card>
          <div>
            <h4 class="text-center text-bold" style="text-transform:uppercase">Padma Bridge Rail Link Project - Phase 2(Bhanga to Jashore)</h4>
            <h5 class="text-center text-bold">Resettlement Unit</h5>
            <h5 class="text-center text-bold">District Wise Payment Report</h5>
          </div>
        </b-card>

        <b-card>
          <div class="mb-1">
            <div class="form-row">
              <div class="col-md-6"></div>
              <div class="col-md-6">
                <button type="button" id="export-table" @click="onexport" class="btn btn-success float-right" style="margin-bottom:5px">
                  Download Excel
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-striped fixed" id="titledExcel">
              <thead>
              <tr>
                <th colspan="0"></th>
                <th colspan="2" scope="colgroup" style="background-color:#F1C230; text-align: center">Faridpur</th>
                <th colspan="2" scope="colgroup" style="background-color:yellow; text-align: center">Gopalganj</th>
                <th colspan="2" scope="colgroup" style="background-color:#F7E238; text-align: center">Narail</th>
                <th colspan="2" scope="colgroup" style="background-color:yellow; text-align: center">Jashore</th>
                <th colspan="2" scope="colgroup" style="background-color:#F7E238; text-align: center">Total</th>
                <th colspan="0">Remarks</th>
              </tr>
              </thead>
              <tr style="background-color:white !important">
                <th style="background-color: #F2F2F2" scope="col">Loss item or Entitlement</th>
                <th style="background-color: #FDE9D9" scope="col">Number of EP</th>
                <th style="background-color: #FDE9D9" scope="col">Amount in BDT</th>
                <th style="background-color: #DBE5F1" scope="col">Number of EP</th>
                <th style="background-color: #DBE5F1" scope="col">Amount in BDT</th>
                <th style="background-color: #E5DFEC" scope="col">Number of EP</th>
                <th style="background-color: #E5DFEC" scope="col">Amount in BDT</th>
                <th style="background-color: #EAF1DD" scope="col">Number of EP</th>
                <th style="background-color: #EAF1DD" scope="col">Amount in BDT</th>
                <th style="background-color: #D8D8D8" scope="col">Number of EP</th>
                <th style="background-color: #D8D8D8" scope="col">Amount in BDT</th>
                <th style="background-color: #FDE9D9" scope="col"></th>
              </tr>
              <tbody>
                <tr v-for="(entitlement_code, index) in entitlement_codes" :key="index">
                  <td style="background-color: #F2F2F2">{{ entitlement_code.code }}</td>
                  <td style="background-color: #FDE9D9">{{ entitlement_code.payment_ep[0] }}</td>
                  <td style="background-color: #FDE9D9">{{ parseFloat(entitlement_code.district_amount[0]).toFixed(2) }}</td>
                  <td style="background-color: #DBE5F1">{{ entitlement_code.payment_ep[1] }}</td>
                  <td style="background-color: #DBE5F1">{{ parseFloat(entitlement_code.district_amount[1]).toFixed(2) }}</td>
                  <td style="background-color: #E5DFEC">{{ entitlement_code.payment_ep[2] }}</td>
                  <td style="background-color: #E5DFEC">{{ parseFloat(entitlement_code.district_amount[2]).toFixed(2) }}</td>
                  <td style="background-color: #EAF1DD">{{ entitlement_code.payment_ep[3] }}</td>
                  <td style="background-color: #EAF1DD">{{ parseFloat(entitlement_code.district_amount[3]).toFixed(2) }}</td>
                  <td style="background-color: #D8D8D8">{{ entitlement_code.total_payment_ep }}</td>
                  <td style="background-color: #D8D8D8">{{ entitlement_code.total_district_amount }}</td>
                  <td style="background-color: #FDE9D9"></td>
                </tr>
                <tr class="customBold">
                  <td class="fixed" style="background-color: #F2F2F2"><b>Total</b></td>
                  <td style="background-color: #FDE9D9"></td>
                  <td style="background-color: #FDE9D9">{{ parseFloat(total_amount[0]).toFixed(2) }}</td>
                  <td style="background-color: #DBE5F1"></td>
                  <td style="background-color: #DBE5F1">{{ parseFloat(total_amount[1]).toFixed(2)  }}</td>
                  <td style="background-color: #E5DFEC"></td>
                  <td style="background-color: #E5DFEC">{{ parseFloat(total_amount[2]).toFixed(2)  }}</td>
                  <td style="background-color: #EAF1DD"></td>
                  <td style="background-color: #EAF1DD">{{ parseFloat(total_amount[3]).toFixed(2)  }}</td>
                  <td style="background-color: #D8D8D8"></td>
                  <td style="background-color: #D8D8D8">{{ total_amount[4] }}</td>
                  <td style="background-color: #FDE9D9"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config.json";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import XLSX from 'xlsx';

export default {
  page: {
    title: "List of Entitlement District All",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader},
  data() {
    return {
      title: "List of Entitlement District All",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "List of Entitlement District All",
          active: true
        }
      ],
      entitlement_codes: {},
      total_amount: {},
      flag: false,
      loader: false,
    };
  },

  mounted() {
    this.getEntitlementDistrictAll();
  },
  methods: {
    getEntitlementDistrictAll() {
      http.get("api/entitlement/district/all").then(response => {
        if (!response.error) {
          this.entitlement_codes = response.data.entitlement_codes;
          this.total_amount = response.data.total_amount;
        }
      });
    },
    onexport(evt) {
      var tbl = document.getElementById('titledExcel');
      var wb = XLSX.utils.table_to_book(tbl);
      XLSX.writeFile(wb, "entitlement-district-all.xlsx");
    },
  },
  computed: {
    userPermission () {
      return this.$store.state.user
    },
  },
  created () {
    this.$store.dispatch('getUserPermission');
  },
};
</script>
<style scoped>
  .fixed th:first-child, .fixed td:first-child
  {
    position:sticky;
    left:0px;
  }

  .customBold td{
    font-weight: bold;
  }
</style>
